import { render } from "./Freelancer.vue?vue&type=template&id=85cef58a&scoped=true"
import script from "./Freelancer.vue?vue&type=script&lang=js"
export * from "./Freelancer.vue?vue&type=script&lang=js"

import "./Freelancer.vue?vue&type=style&index=0&id=85cef58a&lang=scss&scoped=true"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85cef58a"]])

export default __exports__